import React from "react";
import { usePanelSimpleStore } from "../../../../stores/use-panel-simple-store";
import { PanelSimpleContainer } from "./styles";
import Panel from "../panel/Panel";

const PanelSimpleEditor = () => {
  const { data } = usePanelSimpleStore((state) => ({
    data: state.data,
  }));

  return (
    <PanelSimpleContainer>
      <Panel data={data} isEditable={true} />
    </PanelSimpleContainer>
  );
};

export default PanelSimpleEditor;
